module.exports = __webpack_public_path__ + "img/active.104d6538.svg";